import { useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import { useEscapeKey } from '../../../Hooks/useEscapeKey';
import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';
import './MobileDrawer.css';

const MobileDrawer = ({ show, onClose, children }) => {
  const { tempedgeTranslator } = useTempEdgeTranslator();

  useEscapeKey(onClose, show);

  useEffect(() => {
    if (!show) return undefined;

    document.body.classList.add('te-no-scroll');
    return () => document.body.classList.remove('te-no-scroll');
  }, [show]);

  return (
    <>
      <div
        className={`te-mobile-menu-backdrop ${show ? 'show' : ''}`}
        onClick={onClose}
        aria-hidden="true"
        data-testid="mobile-drawer-backdrop"
      />

      <aside className={`te-mobile-menu ${show ? 'show' : ''}`} aria-hidden={!show} data-testid="mobile-drawer">
        <div className="te-mobile-menu-header">
          <button
            type="button"
            className="te-icon-btn"
            onClick={onClose}
            aria-label={tempedgeTranslator('com.tempedge.msg.label.close')}
            data-testid="mobile-drawer-close"
          >
            <FaTimes />
          </button>
        </div>

        <div className="te-mobile-menu-body">{children}</div>
      </aside>
    </>
  );
};

export default MobileDrawer;
